import Model, { attr, belongsTo } from '@ember-data/model';
import type Employee from 'garaje/models/employee';
import type Flow from 'garaje/models/flow';

export default class InviteTemplate extends Model {
  @attr('number') declare additionalGuests: number;
  @attr('string') declare email: string;
  @attr('string') declare fullName: string;
  @attr('string') declare privateNotes: string;
  @attr('string') declare propertyNotes: string;
  @attr('immutable') declare userData: Readonly<Record<string, string>>;

  @belongsTo('employee', { async: false, inverse: null }) declare employee: Employee;
  @belongsTo('flow', { async: false, inverse: null }) declare flow: Flow;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'invite-template': InviteTemplate;
  }
}
